// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__21hA-","emails":"CreateEditClinics_emails__Jjvdo","emailTagLabel":"CreateEditClinics_emailTagLabel__100-E"};